<template>
    <div class="form-group" :class="model.size">
        <label class="font-weight-bold" :class="labelClasses">
            {{ isEnVersion ? model.labelEn : model.label }}
        </label>
        <component :is="dropdownComponent"
                   :model="model"
                   :name="'dropdown' + _uid"
                   :data-vv-as="model.label"
                   v-validate="validations"
                   :filter="'contains'"
                   v-model="selectedValue"
                   :details="details"
                   :isNew="isNew"
                   :class="model.fieldCode"
                   aria-describedby="descriptionHelp">
        </component>
        <small id="descriptionHelp" class="form-text text-muted">{{ isEnVersion ? model.descriptionEn : model.description }}</small>
        <span class="text-danger" v-if="errors.has('dropdown' + _uid)">{{ errors.first('dropdown' + _uid) }}</span>
    </div>
</template>

<script>
    import NomenclatureDropdown from '../dynamic/NomenclatureDropdown';
    import StaticRegisterDropdown from '../dynamic/StaticRegisterDropdown';
    import DynamicRegisterDropdown from '../dynamic/DynamicRegisterDropdown';
    import { DropdownType } from '../../models/enums';
    import { EditorComponentModel } from '../../models/models';
    import { mapGetters } from 'vuex';

    export default {
        inject: ['$validator'],
        props: {
            model: EditorComponentModel, // TODO:
            isNew: {
                type: Boolean,
                default: false
            },
            details: {
                type: Boolean,
                default: false
            },
            allowAnonymous: {
                type: Boolean,
                default: true
            },
            profileData: {
                type: Object,
                default() {
                    return null;
                }
            },
            isEvaluationPanel: {
                type: Boolean,
                default: false
            }
        },
        components: {
            NomenclatureDropdown,
            StaticRegisterDropdown,
            DynamicRegisterDropdown
        },
        data() {
            return {
                dropdownComponent: '',
                labelClasses: '',
                validations: '',
                selectedValue: ''
            }
        },
        methods: {
            addProperDropdown() {
                switch (this.model.dropdownType) {
                    case DropdownType.Nomenclature:
                        this.dropdownComponent = NomenclatureDropdown;
                        break;
                    case DropdownType.Register:
                        this.dropdownComponent = StaticRegisterDropdown;
                            break;
                    case DropdownType.DynamicRegister:
                        this.dropdownComponent = DynamicRegisterDropdown;
                        break
                }
            },
            addValidations() {
                if (this.model.isRequired && !(this.model.dropdownType === DropdownType.Register)) {
                    this.labelClasses = 'required';
                    this.addValidation('required');
                }
            },
            addValidation(validation) {
                if (this.validations.length > 0) {
                    this.validations += '|';
                }
                this.validations += validation;
            },
            fillProfileData(data) {
                if (!data) {
                    return;
                }

                this.$helpers.fillProfileDataToDynamicForm(this.model, data);
            }
        },
        computed: {
            ...mapGetters(['isEnVersion']),
        },
        watch: {
            'model.fieldValue.textValue': function(newVal, oldVal) {
                this.selectedValue = newVal;
/*                if (this.model.isMultiDropdown) {
                    this.model.fieldValue.textValue = newVal;
                } else {
                    this.model.fieldValue.intValue = newVal;
                } */
            },
            'model.fieldValue.intValue': function(newVal, oldVal) {
                this.selectedValue = newVal;
                if (this.model.isMultiDropdown) {
                    this.model.fieldValue.textValue = newVal;
                }
                /* else {
                    this.model.fieldValue.intValue = newVal;
                } */
            },
            profileData: {
                handler: function (newVal, oldVal) {
                    this.fillProfileData(newVal);
                },
                deep: true,
                immediate: true,
            },
        },
        mounted() {
            if (this.model.fieldCode === 'Event_Main_Activity') {
                // console.log(this.model);
            }
            this.selectedValue = this.model.isMultiDropdown ? this.model.fieldValue.textValue : this.model.fieldValue.intValue;
            this.addProperDropdown();
            this.addValidations();
            this.model.uid = this._uid;
            this.model.isEvaluationPanel = this.isEvaluationPanel;
        }
    }
</script>
